const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
/**
 * 获取视频封面
 * @param {String} url 视频地址
 * @returns 
 */
const getVideoBaseInfo = (url) => {
    let video = document.createElement("video");
    video.setAttribute("width", "10");
    video.setAttribute("height", "10");
    video.setAttribute(
        "style",
        "position: absolute;opacity: 0;z-index: -5;top: 0;"
    );
    video.setAttribute("src", url);
    document.body.appendChild(video);
    return new Promise((resolve) => {
        let canplayFn = (e) => {
            let duration = video.duration
            video.removeEventListener("canplay", canplayFn, false)
            document.body.removeChild(video);
            video = null
            resolve({
                scale: [e.target.videoWidth, e.target.videoHeight],
                duration: duration,
                url: url
            });
        }
        video.addEventListener("canplay", canplayFn, false);
        if (isIOS) {
            video.load()
        }

    })
}
/**
 * 获取视频封面
 * @param {String} url 视频地址
 * @param {Array} times 时间数组
 * @param {Function} cb 回调方法
 * @returns 
 */
const getVideoFrame = (url, times = [], cb) => {
    if (!Array.isArray(times))
        times = []
    return getVideoBaseInfo(url).then(fileInfo => {
        return new Promise((resover, reject) => {
            let base64FrameList = []
            let videoEle = document.createElement("video");
            let timeupdateFn = () => {
                let canvas = document.createElement("canvas"),
                    width = videoEle.width, //canvas的尺寸和图片一样
                    height = videoEle.height;
                if (isIOS) {
                    canvas.width = document.body.clientWidth;
                    canvas.height = document.body.clientHeight;
                    let ctx = canvas.getContext("2d")
                    ctx.rotate(Math.PI / 2)
                    ctx.drawImage(videoEle, 0, - fileInfo.scale[0], canvas.height, canvas.width); //绘制canvas
                    // document.title = fileInfo.scale[1] + '-' +  fileInfo.scale[0]
                    // canvas.width = fileInfo.scale[0];
                    // canvas.height = fileInfo.scale[1];
                    // let ctx = canvas.getContext("2d")
                    // ctx.rotate(Math.PI / 2)
                    // ctx.drawImage(videoEle, 0, - canvas.width, canvas.height, canvas.width); //绘制canvas
                } else {
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext("2d").drawImage(videoEle, 0, 0, width, height); //绘制canvas
                }
                let base64Cover = canvas.toDataURL("image/jpeg");
                canvas = null
                base64FrameList.push(base64Cover)
                cb && typeof (cb) == "function" && cb({ frames: base64FrameList, info: fileInfo })
                if (base64FrameList.length >= times.length) {
                    videoEle.removeEventListener("timeupdate", timeupdateFn, false)
                    videoEle = null
                    resover({ frames: base64FrameList, info: fileInfo })
                } else {
                    videoEle.currentTime = times[base64FrameList.length]
                }
            }
            let loadeddataFn = () => {
                videoEle.currentTime = times.length == 0 ? 1 : times[0]; //指定帧数
                videoEle.removeEventListener("loadeddata", loadeddataFn, false)
            }
            videoEle.setAttribute("crossOrigin", "anonymous"); //处理跨域
            videoEle.setAttribute("src", fileInfo.url);
            if (isIOS) {
                // videoEle.setAttribute("width", window.innerWidth);
                // videoEle.setAttribute("height", window.innerHeight);
                videoEle.setAttribute("preload", "auto");
                videoEle.addEventListener("timeupdate", timeupdateFn, false);
                videoEle.setAttribute("muted", true)
                videoEle.play();
                let timer = setTimeout(function () {
                    videoEle.currentTime = times.length == 0 ? 1 : times[0];
                    clearTimeout(timer);
                }, 200);
            } else {
                videoEle.setAttribute("width", fileInfo.scale[0]);
                videoEle.setAttribute("height", fileInfo.scale[1]);
                videoEle.setAttribute("preload", "auto");
                videoEle.addEventListener("timeupdate", timeupdateFn, false);
                videoEle.addEventListener("loadeddata", loadeddataFn, false)
            }

        })
    })

}

/**
 * 将base64转为file
 * @param {String} base64 base64文件
 * @param {String} filename 文件后缀名
 * @returns 
 */
const base64toFile = (base64, filename) => {
    var arr = base64.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}
/**
   * 将base64转为file
   */
function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}
export {
    isIOS,
    getVideoBaseInfo,
    getVideoFrame,
    base64toFile,
    dataURLtoFile
}